export const uri = {
    login: { // 登陆模块
        login: { // 登陆
            path: '/login',
            notLogin: true
        },
        googleLogin: {
            path: '/googleLogin',
            notLogin: true
        },
        changePassword: '/saveChangePassword' // 修改密码
    },
    system: { // 系统管理模块
        update: '/system/updateSystem', // 管理系统升级接口
        engineUpdate: '/engine/update', // 设备引擎升级接口
        engineList: '/engine/list/', // 设备引擎列表
        engineVersionCheck: '/engine/checkDeviceEngineVersion', // 设备引擎版本检查
        engineCheckVersionCode: '/engine/checkVersionCode', // 设备引擎升级versionCode校验接口
        paramVersion: '/system/getSystemVersion', // 系统参数列表获取
        paramList: '/system/list', // 系统参数列表获取
        paramGet: '/system/edit', // 系统参数获取
        paramSave: '/system/saveEdit', // 系统参数修改
        logGet: '/syslog/edit/', // sysLog参数获取
        logSave: '/syslog/saveEdit', // sysLog参数修改
        engineCodeList: '/bmEngine/list', // 引擎编码表列表
        engineCodeInfo: '/bmEngine/edit', // 引擎编码信息
        engineCodeAdd: '/bmEngine/saveAdd', // 引擎编码新增
        engineCodeChange: '/bmEngine/saveEdit', // 引擎编码修改
        engineCodeDelete: '/bmEngine/delete', // 引擎编码删除
        license: '/system/activateLicense/', // license激活接口
        licenseOnLine: 'system/activateLicenseOl/', //license在线激活接口
        licenseGet: '/system/getLicense',
        updateRecord: '/engine/record/',
        updateRecordDetail: '/engine/record/device/',
        diskSpace: '/system/diskSpace',
        staticToken: '/system/staticToken',  //获取静态token
        systemPackage: '/system/systemPackage/list', //获取系统升级包列表
        enginePackage: '/engine/enginePackage/list', //获取云机升级包列表
        enginePrepare: '/engine/devicePrepare/list', //预下载任务列表
        engineUpdateChunk: '/engine/update/chunk', // 设备引擎升级接口
    },
    user: { // 用户管理模块
        list: '/user/list', // 用户信息列表
        groupList: '/userGroup/list', // 用户组信息列表
        infoGet: '/user/edit', // 用户信息
        add: '/user/saveAdd', // 用户新增
        infoSave: '/user/saveEdit', // 用户修改
        delete: '/user/delete', // 用户删除
        groupInfo: '/userGroup/edit', // 用户组信息
        groupAdd: '/userGroup/saveAdd', // 用户组新增
        groupInfoSave: '/userGroup/saveEdit', // 用户组修改
        groupDelete: '/userGroup/delete', // 用户组删除
        groupMerge: '/userGroup/saveGroupUserGroupMerge/', // 用户组关联分组
        getGoogleAuthenticator: '/user/getGoogleAuthenticator/', //获取谷歌登录验证信息
        bindGoogleAuthenticator: '/user/bindGoogleAuthenticator/',//绑定谷歌验证信息
        resetGoogleAuthenticator: '/user/resetGoogleAuthenticator/',//重置谷歌验证信息
        userProxy: '/user/saveUserProxyMerge/', //IP代理关联
        ttl: '/user/ttl', //延长用户账号有效期
        reuse: '/user/reuse',//启用到期用户
    },
    device: { // 设备管理模块
        caseList: '/case/list', // 设备池列表
        caseInfo: '/case/edit', // 设备池信息
        caseInfoByCaseNo: '/case/getByCaseNo', // 设备池信息
        caseInfoSave: '/case/saveEdit', // 设备池信息修改
        scanNode: '/case/scanNode', // 扫描分层处理器
        scanDevice: '/case/scanDevice', // 扫描设备
        scanDeviceWithoutNode: '/case/scanDeviceWithoutNode',//扫描设备（不带分层）
        addDevice: '/case/addDevice', // 手动添加设备(带分层)
        addDeviceWithoutNode: '/case/addDeviceWithoutNode', //手动添加设备（不带分层）
        caseDelete: '/case/delete', // 设备池删除
        deviceList: '/device/list', // 设备信息列表
        deviceInfo: '/device/edit', // 设备信息
        deviceReboot: '/device/reboot', // 设备重启
        deviceRecover: '/device/recover', // 设备回收
        deviceRestore: '/device/restore', // 设备恢复出厂设置
        deviceDelete: '/device/delete', // 设备删除
        deviceGrouping: '/device/grouping', //
        updateDeviceIp: '/case/updateDeviceIp', // 设备池IP修改
        snapshot: '/device/snapshot/', // 设备截图
        qrCode: '/device/idCode/', // 云机识别码
        backHome: '/device/home/', // 云机识别码
        turnAdb: '/device/turnAdb/', // 开关ADB
        startApp: '/device/startApp/', // 开关ADB
        stopApp: '/device/stopApp/', // 开关ADB
        sync: '/device/sync/', // 开关ADB
        startProxy: '/device/startProxy/', // 开关ADB
        stopProxy: '/device/stopProxy/', // 开关ADB
        changeRemark: '/device/saveEdit', //修改云机备注
        avSwitch: '/device/avSwitch', //音视频切换
        getDeviceParam: '/device/getDeviceParam', //获取机型参数
        edit: '/device/edit', //获取设备信息,
        switchRoot: "/device/switchRoot", //ROOT开关
        rootApp: "device/rootApp", //应用ROOT权限
        getFlowDeviceId: "/device/getFlowDeviceId", //获取动态deviceId
        getManageDeviceInfo: '/device/getManageDeviceInfo', //获取管理卡信息
        installGoogle: "/device/googleInstall", //安装Google框架
        refreshMedia: "/device/mediaPoolRefresh", //刷新媒体库
        rebootCross: "/device/rebootCross", //未添加设备跨板重启
        writeCamera: "/device/writeCamera",//摄像头导入图片
        writeCameraBatch: "/device/writeCameraBatch",//导入图片到摄像头批量设备
        devicePing: "/device/ping",//设备连通性测试
        containerOnOff: "/device/containerOnOff",//容器的开关机接口
    },

    apk: { // 应用模块管理
        apkList: '/apk/list', // 应用信息列表
        apkInfo: '/apk/edit', // 应用信息
        apkInfoSave: '/apk/saveEdit', // 应用信息修改
        apkAdd: '/apk/saveAdd', // 应用新增
        apkNewAdd: '/apk/saveAdd/newAppId', //应用新增（不根据包名更新）
        apkDelete: '/apk/delete', // 应用删除
        apkGroupMerge: '/apk/saveApkGroupMerge', // 应用关联分组
        apkOff: '/apk/off', // 应用下架
        apkUp: '/apk/up', //应用上架
        apkMonitorDelete: '/apkIssued/delete', //应用安装监控信息删除
        apkMonitorDeleteAll: '/apkIssued/deleteAll', //应用安装监控信息全部删除
        apkMonitor: '/apkIssued/list', //应用安装监控信息列表
        apkSticky: '/apkIssued/top'
    },
    apkBlack: {
        list: '/appBlacklist/list', //黑名单应用列表
        add: '/appBlacklist/saveAdd', //黑名单应用添加
        delete: '/appBlacklist/delete', //黑名单应用删除
    },
    group: { // 分组管理模块
        list: '/group/list', // 分组信息列表
        info: '/group/edit', // 分组信息
        add: '/group/saveAdd', // 分组新增
        infoSave: '/group/saveEdit', // 分组修改
        delete: '/group/delete', // 分组删除
        deviceMerge: '/group/saveGroupDeviceMerge', // 分组关联设备
        apkMerge: '/group/saveGroupApkMerge', // 分组关联应用
        uploadConfigureFile: '/group/uploadConfigureFile' // 配置文件上传
    },
    log: { // 日志管理模块
        operationLog: '/log/operation', // 操作日志列表
        dispatchLog: '/log/dispatch', // 调度日志列表
        operationLogDelete: '/log/deleteOperation', // 操作日志删除
        dispatchLogDelete: '/log/deleteDispatch', // 调度日志删除
        groupLog: '/log/group', // 分组日志列表
        groupLogDelete: '/log/deleteGroup', // 分组日志删除
        opsList: '/log/devops/', // 运维日志列表
        opsDel: '/log/deleteDevops/', // 运维日志删除
        deviceLog: '/log/device',//设备日志
    },
    help: { // 帮助中心
        faqList: '/faq/list', // FAQ信息列表
        faqInfo: '/faq/edit', // FAQ信息
        faqAdd: '/faq/saveAdd', // FAQ信息新增
        faqModify: '/faq/saveEdit', // FAQ信息修改
        faqDelete: '/faq/delete', // FAQ信息删除
        funClassList: '/introductionCategory/list', // 功能介绍大类信息列表
        funClassInfo: '/introductionCategory/edit/', // 功能介绍大类信息
        funClassAdd: '/introductionCategory/saveAdd', // 功能介绍大类信息新增
        funClassModify: '/introductionCategory/saveEdit', // 功能介绍大类信息修改
        funClassDelete: '/introductionCategory/delete', // 功能介绍大类信息删除
        funList: '/introduction/list', // 功能介绍信息列表
        funInfo: '/introduction/edit', // 功能介绍信息
        funAdd: '/introduction/saveAdd', // 功能介绍信息新增
        funModify: '/introduction/saveEdit', // 功能介绍信息修改
        funDelete: '/introduction/delete', // 功能介绍信息删除
        funImgAdd: '/uploadFile', // 功能介绍信息图片增加
    },
    file: {
        fileList: '/fileIssue/list/', //文件信息列表
        fileInfo: '/fileIssue/edit/', //文件信息
        fileAdd: '/fileIssue/saveAdd/', //文件新增
        fileEdit: '/fileIssue/saveEdit/', //文件修改
        fileDel: '/fileIssue/delete/', //文件删除
        fileIssue: '/fileIssue/issue/', //文件分发
        record: '/fileIssue/record/', //文件分发
        recordDetail: '/fileIssue/record/detail', //文件分发
        recordDel: '/fileIssue/delete/record/', //文件分发
        saveAddChunk: '/fileIssue/saveAddChunk/' //文件（分片）新增
    },
    chunkUpload: {
        checkStatus: '/chunkUpload/checkStatus/', //查询分片状态
        upload: '/chunkUpload/upload/', //分片上传
        merge: '/chunkUpload/merge/', //分片合并
        deleteAll: '/chunkUpload/deleteAll/', //清理分片缓存
    },
    ipProxy: {
        list: '/proxy/list/', //代理信息列表
        edit: '/proxy/edit/', //代理信息
        add: '/proxy/saveAdd/', //代理新增
        save: '/proxy/saveEdit/', //代理修改
        del: '/proxy/delete/', //代理删除
    },
    publicIp: {
        list: '/publicIp/list/', //公网IP列表
        edit: '/publicIp/edit/', //公网IP信息
        add: '/publicIp/saveAdd/', //公网IP新增
        save: '/publicIp/saveEdit/', //公网IP修改
        del: '/publicIp/delete/', //公网IP删除
        distribute: '/publicIp/distribute/', //分配公网IP
        distributeBatch: '/publicIp/distributeBatch/',//批量分配或解除公网IP
        importCsv: '/publicIp/importCsv/' //导入CSV
    },
    cmd: {
        list: '/commandForwarding/list/', //消息信息列表
        edit: '/commandForwarding/edit/', //
        forward: '/commandForwarding/forwarding/', //
        add: '/commandForwarding/saveAdd/', //
        save: '/commandForwarding/saveEdit/', //
        del: '/commandForwarding/delete/', //
        record: '/commandForwarding/record/', //
        recordDel: '/commandForwarding/record/delete/', //
        recordDetail: '/commandForwarding/record/detail/', //
    },
    devMaster: {
        list: '/deviceMasterGreen/list/', //
        saveEdit: '/deviceMasterGreen/saveEdit/', //备份信息修改
        record: '/deviceMasterGreen/record/', //
        backup: '/deviceMasterGreen/backup/', //
        restore: '/deviceMasterGreen/restore/', //
        upload: '/deviceMasterGreen/upload/', //
        del: '/deviceMasterGreen/delete/', //
        switchModel: '/deviceMasterGreen/switchModel', //切换机型
        cleanApp: '/deviceMasterGreen/cleanApp',//清理应用
        editDeviceParam: '/deviceMasterGreen/editDeviceParam', //自定义机型参数
        getBrandModel: '/deviceMasterGreen/getBrandModel', //获取品牌型号
        dataModeling: '/deviceMasterGreen/dataModeling', //数据模拟
        unInstallGoogle: '/deviceMasterGreen/uninstallGoogleFramework/', //谷歌卸载
    },
    live: {
        list: '/live/list/',
        edit: '/live/edit/',
        add: '/live/saveAdd/',
        del: '/live/delete/',
        start: '/live/start/',
    },
    database: {
        list: '/database/list',
        backup: '/database/backup',
        restore: '/database/restore',
        del: '/database/delete',
    },
    ops: {
        list: '/operation/list',
        request: '/operation/saveAdd',
        detail: '/operation/edit',
        del: '/operation/delete',
        checkPort: '/operation/checkPort',
        stop: '/operation/stop',
        restart: '/operation/restart/'
    },
    ipWhiteList: {
        list: '/ipWhiteList/list',
        edit: '/ipWhiteList/edit/',
        saveAdd: '/ipWhiteList/saveAdd',
        saveEdit: 'ipWhiteList/saveEdit',
        delete: '/ipWhiteList/delete',
    },
    guardMaster: {
        guardApp: '/guardMaster/guardApp' //守护大师
    },
    virtualLocation: {
        switch: '/virtualLocation/switch', //虚拟定位
        switchByArea: '/virtualLocation/switchByArea', //根据地区定位
        selectNation: '/virtualLocation/selectNation', //选择国家
        selectPro: '/virtualLocation/selectPro', //选择省
        selectCity: '/virtualLocation/selectCity', //选择市
        selectCounty: '/virtualLocation/selectCounty', //选择区
        listBaseStation: '/virtualLocation/listBaseStation' //获取基站信息
    },
    deviceMirror: {
        list: '/deviceMirror/list', //设备镜像列表
        listOperation: '/deviceMirror/listOperation', //设备镜像操作列表
        edit: '/deviceMirror/edit', //设备镜像信息
        save: '/deviceMirror/save', //设备镜像保存
        switch: '/deviceMirror/switch', //设备镜像切换
        delete: '/deviceMirror/delete', //设备镜像删除
        saveEdit: '/deviceMirror/saveEdit', //修改镜像备注
        cancelOccupation: '/deviceMirror/CancelOccupation/', //取消镜像占用
        switchProxy: '/deviceMirror/switchProxy',//切换IP代理
        cancel: '/deviceMirror/CancelSwitch/',//取消切换镜像
        downloadLog: '/deviceMirror/downloadDeviceMirrorLogFile/', //下载镜像日志文件
    },
    dbPhone: {
        list: '/dbPhone/list', //机型池列表
        edit: '/dbPhone/edit', //机型信息
        listBrand: '/dbPhone/listBrand',//品牌列表
        onOff: '/dbPhone/onOff',//批量启停
        batchNation: '/dbPhone/batchNation',//批量设置国家
    },
    temperatureRecord: {
        list: '/temperatureRecord/list', //温度列表
    }
}